import { useMediaQuery } from 'react-responsive';
import utils from '../utils';

const UseIsMobile = () => {
  return useMediaQuery({
    query: `(max-width: ${utils.breakpoints.md}px)`,
  });
};

export default UseIsMobile;
